import {useParams as useParamsReactRouterDom} from 'react-router-dom';

import {Brand} from '@shared/lib/type_utils';

export function useParams<
  T extends Record<string, string | Brand<string, unknown> | undefined>,
>(): Partial<T> {
  return useParamsReactRouterDom() as Partial<T>;
}
